module.exports = __webpack_public_path__ + "img/52002773_L.f0599b0d.png";